import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from 'app/shared/services/currency-service/currency.service';

@Pipe({
    name: 'currencyPortfolio',
    standalone: false
})
export class CurrencyPortfolioPipe implements PipeTransform {
  constructor(
    private currencyService: CurrencyService
  ) { }

  transform(value: string): string {
    return value + this.currencyService.getCurrencySymbol();
  }
}
